import React, { memo } from 'react';
import { object, string, func } from 'prop-types';
import classNames from 'classnames/bind';

import AutosaggestPopin from 'components/AutosaggestPopin';
import AutosuggestManu from 'components/AutosuggestManu';
import Hint from 'components/Hint';

import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';
import { withSearchContext } from 'containers/withSearchContext';

import CheckIcon from 'media/icons/checkmark.icon.svg';
import styles from './FieldSearchManu.module.scss';
const cx = classNames.bind(styles);

const FieldSearchManu = ({
  contextSearch: {
    isPartTooltip,
    isManuTooltip,
    isErrorManu,
    isSelectedManu,
    isSelectedCar,
    isSelectedModel,
    isSelectedCarPlate,
    setIsManuTooltip,
  },
  updatePartValue,
  setCarInputValue,
  setModelInputValue,
  setDataModels,
  className,
  labels,
  pageType,
}) => (
  <AutosaggestPopin
    tooltipStatus={isManuTooltip}
    toggleTooltip={setIsManuTooltip}
    inputLabel={labels.searchCarLabel}
    className={cx(className, 'search-car', {
      'opened-tooltip': isPartTooltip || isManuTooltip,
    })}
  >
    <div
      className={cx('form-control-item', {
        'is-filled': isSelectedManu && !isSelectedCarPlate,
      })}
    >
      <AutosuggestManu
        className={cx('form-control', {
          'is-error': !isSelectedManu && isErrorManu,
        })}
        type="text"
        pageType={pageType}
        id="search-manu"
        placeholder={labels.searchManufacturePlaceholder}
        updatePartValue={updatePartValue}
        setDataModels={setDataModels}
        setCarInputValue={setCarInputValue}
        setModelInputValue={setModelInputValue}
      />

      <div
        className={cx('error-message', {
          'is-error': !isSelectedManu && isErrorManu,
        })}
      >
        {labels.errorVehicleManu}
      </div>
      <div className={cx('icon-check')}>
        <CheckIcon />
      </div>
      {pageType === 'home' && !isSelectedCar && (
        <Hint
          className={cx('hint', {
            'is-manu-selected': isSelectedManu && !isSelectedModel,
            'is-model-selected': isSelectedModel && !isSelectedCar,
            'is-cartype-selected': isSelectedCar,
          })}
        >
          {!isSelectedManu && (
            <span className={cx('hint-text')}>
              Start with the manufacture information
            </span>
          )}
          {isSelectedManu && !isSelectedModel && (
            <span className={cx('hint-text')}>
              Start with the vehicle model information
            </span>
          )}
          {isSelectedModel && (
            <span className={cx('hint-text')}>
              Start with the car type information
            </span>
          )}
        </Hint>
      )}
      <button
        className={cx('btn', 'btn-next', 'mobile-button')}
        type="button"
        disabled={!isSelectedManu}
        onClick={() => {
          setIsManuTooltip(false);
        }}
      >
        <span className={cx('btn-text')}>{labels.searchCarButtonText}</span>
      </button>
    </div>
  </AutosaggestPopin>
);

FieldSearchManu.propTypes = {
  labels: object.isRequired,
  contextSearch: object.isRequired,
  pageType: string.isRequired,
  className: string.isRequired,
  setDataModels: func.isRequired,
  setModelInputValue: func.isRequired,
  setCarInputValue: func.isRequired,
  updatePartValue: func.isRequired,
};

export default memo(
  withSearchContext(withLabels(withErrorBoundary(FieldSearchManu)))
);



// WEBPACK FOOTER //
// ./src/components/CarIncrementalSearch/components/FieldSearchManu/FieldSearchManu.js